import React, { useEffect, useRef, useState } from 'react'

function computeDistanceFromCenter(component){
  return (component.getBoundingClientRect().top+(component.offsetHeight/2)) - (window.innerHeight / 2)
}


const MovingText = () => {

  const [translateOne, setTranslateOne] = useState(-50)
  const [translateTwo, setTranslateTwo] = useState(-50)

  const wrapperRef = useRef(null)

  useEffect(()=>{
    const scrollFunc = ()=>{
        let distance = computeDistanceFromCenter(wrapperRef.current)
        let absDistance = Math.abs(distance)

        if(absDistance > window.innerHeight/2){
          return;
        }

        let direction = Math.sign(distance)

        // porto il progresso tra -1 e 1 con direction*2*(x - x_min)/(x+x_{max})
        let progress = direction*2*(absDistance)/(absDistance+(window.innerHeight/2)) 

        setTranslateOne(-50+50*progress)
        setTranslateTwo(-50-50*progress)
    }

    scrollFunc()
    window.addEventListener('scroll', scrollFunc, { passive: true });
    window.addEventListener('resize', scrollFunc);

    return () => {
      window.removeEventListener('scroll', scrollFunc);
      window.removeEventListener('resize', scrollFunc);
    };
  }, [])
  return (
    <section className='w-screen bg-brand-black overflow-hidden py-12 sm:py-24' ref={wrapperRef}>
        <div>
            <h1 
              style={{ transform: `translateX(${translateOne}%)` }}
              className='font-display text-nowrap uppercase  text-[clamp(6rem,20vw,22rem)] text-transparent [-webkit-text-stroke:2px_#F4F4F460] font-black leading-none'
            >
              AI ON CAMPUS AI ON CAMPUS AI ON CAMPUS
            </h1>
        </div>
        <div>
            <h1 
              style={{ transform: `translateX(${translateTwo}%)` }}
              className='font-black text-brand-blue font-display text-nowrap uppercase text-[clamp(6rem,20vw,22rem)] leading-none'
            >
              STUDENT CLASH STUDENT CLASH STUDENT CLASH
            </h1>
        </div>
    </section>
  )
}

export default MovingText